/**
 * Get the questions from the ownProps.
 */

import type { RootState } from '/business/shared/state/store';
import flattenQuestions from '/business/shared/functions/flattenQuestions';
import decorateQuestions from '/business/shared/functions/decorateQuestions';
import DevError from '/shared/errors/DevError';
import type { QuestionTreeItem } from '/business/shared/functions/types';
import type { Step1SelectorProps } from '/business/shared/state/selectors/types';

const EMPTY_QUESTIONS: QuestionTreeItem[] = [];

export default (
  _state: RootState,
  ownProps: Step1SelectorProps | string | string[] | null = null,
): QuestionTreeItem[] | null => {
  if (!ownProps) {
    return null;
  }
  if (typeof ownProps === 'string') {
    return [{ path: ownProps }];
  }
  if (Array.isArray(ownProps)) {
    return [{ path: ownProps }];
  }
  if (ownProps?.path) {
    return [{ path: ownProps.path }];
  }
  if (ownProps?.questions) {
    if (!Array.isArray(ownProps.questions)) {
      throw new Error("You have provided an object as 'questions'. This should be the singular 'question' or an array");
    }
    if (ownProps.questions.length === 0) {
      return EMPTY_QUESTIONS;
    }
    if (ownProps.questions[0].depth === undefined && ownProps.questions[0].type === undefined) {
      return flattenQuestions(decorateQuestions(ownProps.questions));
    }
    return ownProps.questions;
  }
  if (ownProps?.question) {
    return [ownProps.question];
  }

  throw new DevError('Could not find questions from props');
};
